'use strict';
const _ = require('lodash');
const Backbone = require('backbone');
const Model = require("../models/category");

module.exports = Backbone.Collection.extend({

      model: Model,
      /**
       *
       */
      initialize: function(attrs, options) {
        this.getVotableCategories();
      },
      /**
       *
       */
      modelId: function(attrs) {
        return attrs.displayName;
      },
      /**
       *
       */
      activeCategories: [],
      /**
       *
       */
      comparator: 'order',
      /**
       * [next description]
       * @param  {[type]}   option [description]
       * @return {Function}        [description]
       */
      next: function(option) {
        if(!this.contains(option)){
          return false;
        }
        var model = this.at(this.indexOf(option) + 1);

        if(_.isUndefined(model)) {
          model = this.last();
        }

        return model;
      },
      /**
       * [prev description]
       * @param  {[type]} option [description]
       * @return {[type]}        [description]
       */
      prev: function(option) {
        if(!this.contains(option)){
          return false;
        }
        var model = this.at(this.indexOf(option) - 1);

        if(_.isUndefined(model)) {
          model = this.first();
        }

        return model;
      },
      /**
       * Return the category that matches the passed ID
       * @param categoryID - ID of the category we want to look up
       */
      getCategoryById: function (categoryID) {
        return this.findWhere({ id: categoryID });
      },
      /**
       * [findSocialCategory description]
       * @return {[type]} [description]
       */
      findSocialCategory: function() {
        var socialCategory;

        _.forEach(this.models, function(model, index) {
          if(model.get('social') == '1') {
            socialCategory = model;
          }
        })

        return socialCategory;
      },
      /**
       * [findSocialCategory description]
       * @return {[type]} [description]
       */
      findTwitterCategory: function() {
        var twitterCategory;

        _.forEach(this.models, function(model, index) {
          if(model.get('live_vote') == '1') {
            twitterCategory = model;
          }
        })

        return twitterCategory;
      },
      /**
       * Returns the next votable category
       * @param lastVotedCatID - we will look for the next votable model starting from this ID
       */
      getNextVotableCategory: function(lastVotedCatID, selectedCatId) {
        var filteredModels = this.getVotableCategories();
        var returnModel = null;

        // if user just logged after clicking the plus button and have selected a votable category, return early
        if(!lastVotedCatID && selectedCatId) {

          returnModel = filteredModels.find(function(model) {
            return model.id === selectedCatId;
          });

          if(!returnModel) returnModel = filteredModels[0];
          return returnModel;
        }

        // if user just logged in via storage (i.e. have not seleted a category manually)
        lastVotedCatID = lastVotedCatID ? lastVotedCatID : -1;

        filteredModels.some(function(model) {
          if (model.id > lastVotedCatID) {
            returnModel = model;
          }
          return model.id > lastVotedCatID;
        });

        // If there are still votable categories and the user reached the end,
        // route them back to the first of the remaining votable categories
        if(filteredModels.length > 0 && !returnModel) {
          returnModel = filteredModels[0];
        }

        return returnModel;
      },
      /**
       * Returns the total number of active categories, including submitted ones
       */
      getTotalActiveCategories: function() {

        var activeCategories = this.where({
          active: '1',
          social: '0',
          live_vote: '0',
          professional: '0'
        });

        return activeCategories.length;
      },
      /**
       * Returns the total number of submitted categories
       */
      getTotalSubmittedCategories: function() {

        var submittedCategories = this.where({
          active: '1',
          social: '0',
          live_vote: '0',
          professional: '0',
          isSubmitted: true
        });

        return submittedCategories.length;
      },
      /**
       * Returns an array of all votable categories
       */
      getVotableCategories: function() {

        var votableCategories = this.where({
          active: '1',
          social: '0',
          professional: '0',
          isSubmitted: false
        });

        return votableCategories;
      },
      /**
       *
       */
      findCategoryByDisplayName: function(display_name) {
        var found;

        this.forEach(function(item, index, list) {
          if(item.get('displayName') == display_name) {
            found = item;
            return true;
          }
        });

        return found;
      }
});



// WEBPACK FOOTER //
// ./app/scripts/collections/category.js